import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { API_ROUTES } from "utils/constant";
import { axiosPost } from "utils/api";

function WhitelistIpAddDialog({ isOpen, onClose, refetch }) {
  const [ip, setIp] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  async function handleSubmit() {
    if (!ip.trim()) {
      toast({
        title: "Vui lòng nhập IP",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    setLoading(true);
    try {
      const res = await axiosPost(API_ROUTES.IpCreate, {
        ip: ip.trim(),
        note: note.trim() || undefined,
      });
      if (res?.data?.code !== 0) {
        toast({
          title: res?.data?.msg || "Thêm thất bại",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }
      toast({
        title: "Đã thêm IP",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      setIp("");
      setNote("");
      refetch?.();
      onClose();
    } catch (error) {
      toast({
        title:
          error?.response?.data?.errors?.[0]?.msg ||
          error?.response?.data?.msg ||
          "Thêm thất bại",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Thêm Whitelist IP</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={4} isRequired>
            <FormLabel>Địa chỉ IP</FormLabel>
            <Input
              placeholder="vd. 139.162.4.24"
              value={ip}
              onChange={(e) => setIp(e.target.value)}
              autoFocus
            />
          </FormControl>
          <FormControl>
            <FormLabel>Ghi chú (tuỳ chọn)</FormLabel>
            <Input
              placeholder="vd. Đối tác Abenla"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button mr={3} onClick={onClose} variant="ghost">
            Huỷ
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleSubmit}
            isLoading={loading}
          >
            Thêm
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default WhitelistIpAddDialog;
